var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglePage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 21,
    height: 26,
    rx: 4,
    stroke: "#0A81FD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.875C6.14844 5.875 5.875 6.14844 5.875 6.5V21.5C5.875 21.8516 6.14844 22.125 6.5 22.125H16.5C16.8516 22.125 17.125 21.8516 17.125 21.5V6.5C17.125 6.14844 16.8516 5.875 16.5 5.875H6.5ZM4 6.5C4 5.13281 5.13281 4 6.5 4H16.5C17.8672 4 19 5.13281 19 6.5V21.5C19 22.8672 17.8672 24 16.5 24H6.5C5.13281 24 4 22.8672 4 21.5V6.5ZM8.6875 9H14.3125C14.8203 9 15.25 9.42969 15.25 9.9375C15.25 10.4453 14.8203 10.875 14.3125 10.875H8.6875C8.17969 10.875 7.75 10.4453 7.75 9.9375C7.75 9.42969 8.17969 9 8.6875 9ZM8.6875 12.75H14.3125C14.8203 12.75 15.25 13.1797 15.25 13.6875C15.25 14.1953 14.8203 14.625 14.3125 14.625H8.6875C8.17969 14.625 7.75 14.1953 7.75 13.6875C7.75 13.1797 8.17969 12.75 8.6875 12.75ZM8.6875 16.5H10.5625C11.0703 16.5 11.5 16.9297 11.5 17.4375C11.5 17.9453 11.0703 18.375 10.5625 18.375H8.6875C8.17969 18.375 7.75 17.9453 7.75 17.4375C7.75 16.9297 8.17969 16.5 8.6875 16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePage);
export default __webpack_public_path__ + "static/media/single_page.9cd36a2393621d5ca37c147326810932.svg";
export { ForwardRef as ReactComponent };